import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
 
@Injectable({
  providedIn: 'root',
})
export class SharedApplicantService {
  private readonly applicantIdSource = new BehaviorSubject<string | null>(null);
  applicantId$ = this.applicantIdSource.asObservable();
 
  private readonly userRoleSource = new BehaviorSubject<string | null>(null);
  userRole$ = this.userRoleSource.asObservable();

  changeApplicantId(id: string | null): void {
    this.applicantIdSource.next(id);
  }
 
  getApplicantId(): string | null {
    return this.applicantIdSource.value;
  }
 
  changeUserRole(role: string | null): void {
    this.userRoleSource.next(role);
  }
  getUserRole(): string | null {
    return this.userRoleSource.value;
  }
}
